import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams, HttpResponse  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from '../../config/config';
import { Observable, throwError } from 'rxjs';
import { map, tap, filter, retry, catchError } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import {AuthService} from './../../login/auth.service';
import {Router} from '@angular/router';
// const base_Url = 'http://mat-mgmt.201.kmmedical.in//api/';

@Injectable()
export class StockService {

  public BASE = BASE_URL.URL;
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8') };
  private userId: any;
  private token: any;

    constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private authService: AuthService, private route: Router) { }

    getStocksForStockPage() {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token')
      };
      return this.http.post(this.BASE + '/stocks/index', param)
        .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getInvoice(e) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token'),
        page: e
      };

      return this.http.post(this.BASE + '/invoices/index', param)
        .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getCountries() {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token')
      };
      return this.http.post(this.BASE + '/countries/index', param)
        .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getLocations() {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token')
      };
      return this.http.post(this.BASE + '/locations/index', param)
        .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getTracking(param) {
      this.spinnerService.show();
      return this.http.post(this.BASE + '/displacements/lists', param)
        .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getProducts(page) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token'),
        page
      };
      return this.http.post(this.BASE + '/products/index', param)
         .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getCountriesByID(url, body, page) {
      this.spinnerService.show();
      const param = {
        token: localStorage.getItem('token'),
        page,
        body
      };
      return this.http.post(this.BASE + url, param)
        .pipe(
          map((res: any) => {
            return res
          }),
          tap(err => this.spinnerService.hide()),
          catchError(this.handleError.bind(this))
        );
    }

    downloadBulkUploadTemplate(type: string) {
      this.spinnerService.show();

      let token = localStorage.getItem('token');

      const link = document.createElement('a');
      document.body.appendChild(link);
      link.href = `${this.BASE}/bulk-stocks/template/${type}?token=${token}`;
      link.setAttribute('type', 'hidden');
      link.click();

      this.spinnerService.hide();
    }

    bulkUpload(data: FormData, type: string) {
      this.spinnerService.show();
      let token = localStorage.getItem('token');

      return this.http.post(`${this.BASE}/bulk-stocks/upload/${type}`, data, {
        responseType: 'blob' as 'json',
        headers: {
          'Authorization': 'Bearer ' + token
        }
        }).pipe(map(res => {
          console.log('sdsvdfg', res);
          return res;

        }), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
    }

    getBulkUploadSummary(page: string = "", uploadedFor: string = "", uploadedAt: string = ""): Observable<any> {
      // Map the tab names to the correct API parameters
      let apiUploadedFor = uploadedFor;
      if (uploadedFor === 'location') {
        apiUploadedFor = 'shipment'; // Convert 'location' to 'shipment' for API
      } else if (uploadedFor === 'warehouse') {
        apiUploadedFor = 'warehouse';
      }
      
      this.spinnerService.show();
      let token = localStorage.getItem('token');

      return this.http.get(`${this.BASE}/bulk-stocks/upload/summary?page=${page}&uploaded_for=${apiUploadedFor}&uploaded_at=${uploadedAt}`, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
        .pipe(
          map((res: any) => {
            return res
          }),
          tap(() => this.spinnerService.hide()),
          catchError(this.handleError.bind(this))
        );
    }

    getBulkUploadSummaryDetails(summaryId: string): Observable<any> {
      this.spinnerService.show();
      let token = localStorage.getItem('token');

      return this.http.get(`${this.BASE}/bulk-stocks/upload/summary/${summaryId}`, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
        .pipe(
          map((res: any) => {
            return res
          }),
          tap(err => this.spinnerService.hide()),
          catchError(this.handleError.bind(this))
        );
    }

    downloadUploadedRecords(id: string): Observable<any> {
      this.spinnerService.show();
      let token = localStorage.getItem('token');

      return this.http.get(`${this.BASE}/bulk-stocks/upload/summary/${id}/download`, {
        responseType: 'blob',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
        .pipe(
          map((res: any) => {
            return res
          }),
          tap(err => this.spinnerService.hide()),
          catchError(this.handleError.bind(this))
        );
    }

    private handleError(error: any){
      if (error.status === 401) {
        localStorage.clear();
        this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
        this.spinnerService.hide();
        return
      }else if(error.status === 422){
        this.spinnerService.hide();
        return throwError(()=> error);
      }
      else{
        console.error('server error:', error);
      }

      // if (error.error instanceof Error) {
      //   const errMessage = error.error.message;
      //   return Observable.throw(errMessage);
      //   // Use the following instead if using lite-server
      //   // return Observable.throw(err.text() || 'backend server error');
      // }
      // return Observable.throw(error || 'Node.js server error');
    }

    /**********************************Purchase order**************************/
    getPurchaseOrder(page: any) {
      const param = {
        token: localStorage.getItem('token'),
        page
      };
      return this.http.post(this.BASE + '/PurchaseOrders/index', param)
         .pipe(map(res => res), catchError(this.handleError.bind(this)));
     }

    // HttpClient API post() method => Create PO
  // tslint:disable-next-line:variable-name
    purchaseOrderCreate(po_inputdata: any) {
      const param = {
        token: localStorage.getItem('token')
      };
      return this.http.post(this.BASE + '/PurchaseOrders/store', JSON.stringify(po_inputdata), this.options)
        .pipe(
        map(res => res),
        catchError(this.handleError.bind(this))
        );
    }

  // tslint:disable-next-line:variable-name
    deletePO(po_delete_id: any) {// needs to rewrite
        return this.http.post<any>(this.BASE + '/purchase-order-delete', JSON.stringify(po_delete_id), this.options)
        .pipe(
            map(res => res),
            catchError(this.handleError.bind(this))
        );
      }

  // tslint:disable-next-line:variable-name
    getPO(purchase_order_id: any) {
        return this.http.post<any>(this.BASE + '/purchaseOrders/formData', JSON.stringify(purchase_order_id), this.options)
        .pipe(
            map(res => res),
            catchError(this.handleError.bind(this))
        );
    }

  // tslint:disable-next-line:variable-name
    updatePO(po_data: any) {// needs to rerwrite
        return this.http.post<any>(this.BASE + '/purchase-order-update', JSON.stringify(po_data), this.options)
        .pipe(
            map(res => res),
            catchError(this.handleError.bind(this))
        );
     }
     /***************************purchase order ends**************************8*/
 updateRFID(rfid_data: any) {// needs to rerwrite
        return this.http.post<any>(this.BASE + '/scanned_implants/store', JSON.stringify(rfid_data), this.options)
        .pipe(
            map(res => res),
            catchError(this.handleError.bind(this))
        );
     }



}
